// Mock data for HSNL Advisory website

export const companyInfo = {
  name: "HSNL Advisory",
  tagline: "Strategic Advisory for Institutional Real Estate & Capital Markets",
  description: "Transaction Advisory | Capital Structuring | Cross-Border Investments",
  email: "info@hsnladvisory.com",
  phone: "+91 9910506820",
  phone2: "+91 9667537111",
  address: "Unit No 504, Good Earth City Center, Sector-50, Gurugram - 122018, Haryana, India"
};

export const founders = [
{
  id: 1,
  name: "Siddharth Kumar",
  title: "Co-Founder",
  education: "Mechanical Engineer & MBA",
  experience: "IndiGo Airlines, Airtel",
  expertise: [
  "Infrastructure procurement",
  "Real estate transactions",
  "Commodity trade facilitation"],

  description: "Extensive experience in navigating complex projects with expertise in infrastructure and commodities.",
  image: "https://customer-assets.emergentagent.com/job_exim-solutions-2/artifacts/lknwj0u8__DSC0749.jpg"
},
{
  id: 2,
  name: "Damandeep Singh",
  title: "Co-Founder",
  education: "Chemical Engineer with MBA",
  experience: "Hindustan Unilever, CP Group",
  expertise: [
  "Strategic partnerships",
  "Investor relations",
  "International trade relationships"],

  description: "Robust background ensuring effective market expansions and strong client connections.",
  image: "https://customer-assets.emergentagent.com/job_exim-solutions-2/artifacts/mjlqnqat_WhatsApp%20Image%202026-03-10%20at%2016.03.10.jpeg"
}];

// Partners - Strategic Network
export const partners = [
{
  id: 1,
  name: "Dr. Himanshu Gupta",
  title: "Director – Administration, Mahaveer Multispecialty Hospital",
  bio: "Dr. Himanshu Gupta is a seasoned healthcare management leader with over 20 years of experience in hospital administration, public health programs, and institutional development. He specializes in operational excellence, governance frameworks, and patient-centric service delivery, with expertise in healthcare strategy, facility expansion, and digital process optimization.",
  image: "https://customer-assets.emergentagent.com/job_exim-solutions-2/artifacts/8crybuuv_Dr.%20Himanshu%20Gupta.png"
},
{
  id: 2,
  name: "V.K. Vidyarthi",
  title: "Former General Manager, APEDA | Export Strategy Advisor",
  bio: "V.K. Vidyarthi is a veteran export professional with 30+ years of experience in international trade and agricultural exports. As former GM at APEDA, he has contributed to export policy development and global market expansion. Currently based in the UAE, he advises on export strategy, compliance, and cross-border trade.",
  image: "https://customer-assets.emergentagent.com/job_exim-solutions-2/artifacts/elia0zz5_V%20K%20Vidyarthi.jpg"
},
{
  id: 3,
  name: "Maj. Gen. K.P. Sinha (Retd.)",
  title: "Strategic Advisor – Defence, Infrastructure & Governance",
  bio: "Maj. Gen. K.P. Sinha (Retd.) is a distinguished Indian Army veteran with decades of leadership experience in strategic operations, infrastructure development, and large-scale project execution. Having served in senior command roles, he brings deep expertise in governance, risk management, and disciplined execution across complex environments.",
  image: "https://customer-assets.emergentagent.com/job_exim-solutions-2/artifacts/1zgf5vnf_WhatsApp%20Image%202026-03-18%20at%2016.07.41.jpeg"
}];


export const services = [
{
  id: 1,
  title: "Real Estate Advisory",
  icon: "Building2",
  shortDescription: "Connecting landowners, developers, and investors across India.",
  description: "We connect landowners, developers, and investors to maximize opportunities in real estate across India.",
  features: [
  "Sale and purchase of land across PAN India for solar parks, industrial parks, warehouses, schools, hospitals, colleges, townships, agricultural estates and resorts",
  "Joint ventures and strategic collaborations for schools, hotels and hospitals",
  "Strategic land acquisitions for developers",
  "Institutional investments in development projects",
  "Residential advisory in Delhi NCR and commercial developments such as Vatika, Worldmark, Unity and other premium projects"],

  transactionTypes: "Land Transactions, JVs, Acquisitions",
  pipelineMetric: "USD 100 Mn+",
  pipelineDescription: "Ongoing advisory mandates across land acquisitions, joint developments, institutional investments and commercial real estate transactions.",
  image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800&h=600&fit=crop"
},
{
  id: 2,
  title: "Investment & Finance Advisory",
  icon: "TrendingUp",
  shortDescription: "Tailored financing and capital structuring for large projects.",
  description: "We offer tailored financing and capital structuring solutions for large projects.",
  features: [
  "Project financing for real estate, data centres, solar and infrastructure",
  "Equity investments and foreign direct investments (FDI)",
  "Structured debt and mezzanine financing",
  "Mergers & acquisitions advisory",
  "Network of private and institutional investors"],

  transactionTypes: "Project Finance, M&A, Equity, Debt",
  typicalSize: "USD 10 Million+",
  pipelineMetric: "USD 500 Million+",
  pipelineDescription: "Ongoing financing mandates across infrastructure, renewable energy and strategic investment opportunities.",
  image: "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=800&h=600&fit=crop"
},
{
  id: 3,
  title: "International Trade",
  icon: "Globe",
  shortDescription: "Global trade facilitation across commodities and energy sectors.",
  description: "We ensure efficient transactions in competitive international markets with credible counterparties.",
  features: [
  "Precious metals and gems",
  "Energy and petrochemical products",
  "Agricultural and food commodities",
  "Industrial materials and products",
  "Specialized aviation assets"],

  transactionTypes: "Global Trade, Commodities, Energy",
  pipelineMetric: "USD 50 Mn+",
  pipelineDescription: "Ongoing trade advisory mandates across commodities, energy products, and specialized assets.",
  image: "https://images.unsplash.com/photo-1526304640581-d334cdbbf45e?w=800&h=600&fit=crop"
}];


export const valuePropositions = [
{
  id: 1,
  title: "Global Investor Network",
  description: "Strategic relationships with institutional investors, family offices, and development partners across key markets",
  icon: "Network"
},
{
  id: 2,
  title: "Transaction Certainty",
  description: "Rigorous due diligence and counterparty verification ensuring seamless transaction execution",
  icon: "Shield"
},
{
  id: 3,
  title: "Institutional Scale",
  description: "Advising on transactions exceeding USD 10 Million with proven track record in large-scale deployments",
  icon: "TrendingUp"
},
{
  id: 4,
  title: "Strategic Positioning",
  description: "Bespoke advisory services aligned with long-term capital deployment and growth objectives",
  icon: "Target"
}];


export const stats = [
{ label: "Combined Industry Experience", value: "50+", icon: "Calendar" },
{ label: "Transactional Pipeline", value: "$1 Billion+", icon: "TrendingUp" },
{ label: "Advisory Verticals", value: "3", icon: "Briefcase" },
{ label: "Market Presence", value: "India | UAE | Africa", icon: "Globe" }];


export const testimonials = [
{
  id: 1,
  name: "Real Estate Developer",
  company: "Leading Development Group",
  feedback: "HSNL Advisory facilitated our largest land acquisition seamlessly. Their network and expertise are unmatched.",
  rating: 5
},
{
  id: 2,
  name: "Investment Firm",
  company: "Private Equity Fund",
  feedback: "Professional, efficient, and highly knowledgeable. They connected us with excellent investment opportunities.",
  rating: 5
},
{
  id: 3,
  name: "Trading Company",
  company: "International Commodities Trader",
  feedback: "Their expertise in international trade has been invaluable. Highly recommended for complex transactions.",
  rating: 5
}];

// Transaction Process Steps
export const transactionProcess = [
{
  step: 1,
  title: "Initial Mandate Discussion",
  description: "Understanding your transaction objectives, requirements and strategic goals"
},
{
  step: 2,
  title: "Investor or Buyer Identification",
  description: "Leveraging our network to identify qualified counterparties"
},
{
  step: 3,
  title: "Due Diligence & Structuring",
  description: "Comprehensive analysis and optimal transaction structure"
},
{
  step: 4,
  title: "Commercial Negotiation",
  description: "Strategic negotiation to maximize value for all parties"
},
{
  step: 5,
  title: "Transaction Execution",
  description: "Seamless coordination through closing and documentation"
}];

// Insights/Articles
export const insights = [
{
  id: 1,
  title: "Future of Solar Land Investments in India",
  category: "Real Estate",
  excerpt: "Analyzing the growth trajectory and investment opportunities in solar park land across India"
},
{
  id: 2,
  title: "Growth of Data Centre Infrastructure",
  category: "Infrastructure",
  excerpt: "Understanding the data centre boom and land acquisition strategies"
},
{
  id: 3,
  title: "Hospitality Development Opportunities",
  category: "Real Estate",
  excerpt: "Strategic locations and partnerships for hotel and resort developments"
},
{
  id: 4,
  title: "Institutional Investment Trends in Indian Real Estate",
  category: "Investment",
  excerpt: "Capital deployment strategies and market dynamics for institutional investors"
}];

// Global Network Locations
export const globalNetwork = [
{
  location: "India",
  description: "Pan-India presence with deep market knowledge and extensive network"
},
{
  location: "Dubai",
  description: "Strategic partnerships in Middle East markets"
},
{
  location: "Singapore",
  description: "Access to Asian capital markets and institutional investors"
},
{
  location: "Europe",
  description: "Connections with European family offices and investment funds"
}];

// Active Mandates Data
export const activeMandates = {
realEstate: {
  pipeline: "USD 100 Mn+",
  mandates: [
    "Hospitality developments",
    "Industrial and logistics parks",
    "Institutional land acquisitions",
    "Township developments",
    "Commercial office developments",
    "Resort and leisure projects"
  ]
},
capitalAdvisory: {
  pipeline: "USD 500 Million+",
  mandates: [
    "Project financing",
    "Equity investments",
    "Structured debt",
    "FDI transactions",
    "M&A advisory",
    "Mezzanine financing"
  ]
}};

// Strategic Opportunities
export const strategicOpportunities = [
{
  id: 1,
  title: "Solar Park Land Acquisitions",
  description: "Large land parcels across multiple states for solar energy development",
  sector: "Renewable Energy"
},
{
  id: 2,
  title: "Data Centre Land",
  description: "Strategic locations with power and connectivity infrastructure",
  sector: "Digital Infrastructure"
},
{
  id: 3,
  title: "Resort Development Land",
  description: "Premium locations for hospitality and leisure developments",
  sector: "Hospitality"
},
{
  id: 4,
  title: "Institutional Joint Ventures",
  description: "Partnership opportunities with established developers",
  sector: "Real Estate"
},
{
  id: 5,
  title: "Large Development Sites",
  description: "Mixed-use and township development opportunities",
  sector: "Real Estate"
}];

// Commodities We Deal In - Detailed Categories
export const commoditiesCategories = [
  {
    id: 1,
    category: "Gemstones",
    icon: "Gem",
    items: ["Emerald"]
  },
  {
    id: 2,
    category: "Gold",
    icon: "Coins",
    items: ["Bullion", "Dore Bar"]
  },
  {
    id: 3,
    category: "Petrochem / Energy Products",
    icon: "Flame",
    items: ["EN590", "LNG", "Nigerian Crude Oil"]
  },
  {
    id: 4,
    category: "Agricultural Products",
    icon: "Sprout",
    items: ["Rice", "Sugar", "Cattle Feed", "Tea"]
  },
  {
    id: 5,
    category: "Metals & Minerals",
    icon: "Box",
    items: ["Iron Ore"]
  },
  {
    id: 6,
    category: "Aviation Equipment",
    icon: "Plane",
    items: ["Aircraft Engines", "GE Engines", "Pratt & Whitney (P&W) Engines"]
  }
];

// Notable Transactions & Strategic Engagements
export const notableTransactions = {
  title: "Notable Transactions & Strategic Engagements",
  description: "We collaborate across a network of global institutions, infrastructure leaders, and strategic partners to facilitate high-value transactions across real estate, capital advisory, and global trade.",
  disclaimer: "Logos represent past or ongoing transaction involvement, advisory engagement, or market interaction and do not imply formal partnerships.",
  companies: [
    {
      id: 1,
      name: "Ross",
      logo: "https://via.placeholder.com/200x80/1e3a8a/FFFFFF?text=ROSS",
      placeholder: true
    },
    {
      id: 2,
      name: "Delamore Capital",
      logo: "https://via.placeholder.com/200x80/1e3a8a/FFFFFF?text=DELAMORE+CAPITAL",
      placeholder: true
    },
    {
      id: 3,
      name: "Al-Bahar CAT",
      logo: "https://via.placeholder.com/200x80/1e3a8a/FFFFFF?text=AL-BAHAR+CAT",
      placeholder: true
    }
  ]
};